import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IFitTablePanPadFormMeta {
    panDataLength: FormInputMeta;
    padPAN: FormInputMeta;

}

const fitTablePanPadFormMeta = {} as IFitTablePanPadFormMeta;

fitTablePanPadFormMeta.panDataLength = {
    name: "panDataLength",
    type: "number",
    label: "Longueur Données PAN",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !"),
};

fitTablePanPadFormMeta.padPAN = {
    name: "padPAN",
    type: "number",
    label: "Pad PAN",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !"),
};


export default fitTablePanPadFormMeta;